import Button from '@ui/atoms/design-system/Button';
import Image from '@atoms/Image';
import Text from '@atoms/Text';
import { productStructuredData } from '@helpers/constants';
import StructuredData from '@components/StructuredData';
import texts from '@components/Products/en.json';
import Video from '@atoms/Video';
import { useState } from 'react';
import useWindowDimensions from 'hooks/useWindowDimensions';
import LazyImage from '@atoms/LazyImage';

const InvoiceProductBanner = ({ selectedProduct, onButtonClick }) => {
    const { banner } = selectedProduct;
    const { width } = useWindowDimensions();

    return (
        <div id={`${banner?.title} Banner`}>
            <StructuredData data={productStructuredData} />
            <div className="mt-4 md:mt-6 xl:mt-4 mx-4 md:mx-6 bg-primary-500 md:rounded-3xl flex flex-col xl:flex-row gap-y-14 md:gap-y-16 xl:gap-x-20 p-4 md:p-10 xl:px-12  xl:py-[76px] bg-id-linear-gradient-banner rounded-2xl">
                <div className="xl:basis-3/5 xl:my-auto">
                    <Text
                        content={texts.whatIs}
                        className="p4-regular md:h3-regular text-basicWhite"
                    />
                    <div className="flex ">
                        <Text
                            content={banner?.title}
                            htmlTag='h1'
                            className="p2-semibold md:h2-semibold text-basicWhite"
                        />
                        {banner?.subtitle && (
                            <Text
                                content={` ${banner?.subtitle}`}
                                className="whitespace-pre p2-regular md:h2-regular text-primary-30"
                                htmlTag='h3'
                            />
                        )}
                        <Text
                            content="?"
                            className="p2-semibold md:h2-semibold text-basicWhite"
                        />
                    </div>
                    <div className="relative mt-6 md:hidden">
                        <VideoBanner banner={banner} key={banner?.title} />
                    </div>
                    <Text
                        content={banner?.productDescription}
                        className="mt-10 md:mt-3 text-primary-10 p5-regular md:p4-regular xl:p5-regular"
                    />
                    <div className="mt-6 md:mt-8 xl:mt-12">
                        <Button
                            widthClass="w-full md:w-auto"
                            buttonType="tertiary"
                            buttonSize={width < 768 ? 'small' : 'regular'}
                            onClick={onButtonClick}
                            buttonText={banner?.bannerButton}
                        />
                    </div>
                </div>
                <div className="relative items-center hidden h-full xl:basis-2/5 md:flex">
                    <VideoBanner banner={banner} key={banner?.title} />
                </div>
            </div>
        </div>
    );
};

const VideoBanner = ({ banner }) => {
    const [isControlsVisible, setIsControlsVisible] = useState(false);

    return (
        <>
            <div className="relative w-full xl:mb-0">
                <LazyImage
                    src="/images/products/v2/product-banner-gradient.png"
                    imgClassName="absolute bottom-0 blur-xl md:-bottom-24 xl:bottom-0 xl:right-0 w-full h-full"
                    className='absolute -top-24 w-full h-full min-h-[380px]'
                />
                <div className="relative z-10 w-full h-full">
                    <div className="gap-y-4 md:gap-y-6 flex flex-col justify-center h-full w-full md:px-[66px] xl:px-0">
                        <Video
                            src={banner?.videoSrc}
                            placeholder={banner?.coverImage}
                            mainWrapperClassName="rounded-xl overflow-hidden"
                            className="w-full h-full object-fit"
                            canPauseOnScroll={true}
                            controls={isControlsVisible}
                            onToggle={(v) => setIsControlsVisible(!v)}
                            controlslist="nodownload noremoteplayback noplaybackrate"
                            customPlayAnimationForCover={true}
                            customControls={!isControlsVisible}
                            customEventNameForCoverPlay={
                                banner?.playGtmEventName
                            }
                            customEventNameForPause={banner?.pauseGtmEventName}
                            customEventNameForCompletion={
                                banner?.completeGtmEventName
                            }
                        />
                        <div className="flex flex-row justify-center w-full">
                            <div className="relative -mr-1 md:-mr-[6px] basis-1/2">
                                <Image
                                    src="/images/products/v2/irr-bg.svg"
                                    className="h-auto xl:h-[72px] w-full"
                                />
                                <div className="absolute top-0 bottom-0 flex flex-col justify-center py-1 ml-3 md:py-2 md:ml-4">
                                    <Text
                                        content={texts?.irr}
                                        className="text-gray-100 p6-regular md:p3-regular"
                                    />
                                    <Text
                                        content={banner?.irr}
                                        className="p6-semibold md:h5-semibold text-basicWhite"
                                    />
                                </div>
                            </div>
                            <div className="relative -ml-1 md:-ml-[6px] basis-1/2">
                                <Image
                                    src="/images/products/v2/tenure-bg.svg"
                                    className="h-auto xl:h-[72px] w-full"
                                />
                                <div className="absolute top-0 bottom-0 flex flex-col justify-center py-1 ml-6 md:py-2 md:ml-8">
                                    <Text
                                        content={texts?.tenure}
                                        className="text-gray-100 p6-regular md:p3-regular"
                                    />
                                    <Text
                                        content={banner?.tenure}
                                        className="p6-semibold md:h5-semibold text-basicWhite"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default InvoiceProductBanner;
